import { HttpClient, HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AuthService } from '../../../service/auth.service';
import { User } from '../../../model/types';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { StorageService } from '../../../service/storage.service';
import { DatePipe } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-data-compilation',
  standalone: true,
  imports: [],
  templateUrl: './data-compilation.component.html',
  styleUrl: './data-compilation.component.scss'
})
export class DataCompilationComponent implements OnInit {
  projectCode: string = '';
  ProjectCodeResults = []
  @ViewChild('RApaginator', { static: false }) paginator?: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort?: MatSort;
  dataSource: MatTableDataSource<any>;
  tableColumns: string[] = ['select', 'Project_Code', 'Target_Name', 'Run_ID', 'analysisDate', 'UserName', 'RunStatus'];
  dataFetched: boolean = false;
  projectRecordUrl: string = environment.serverUrl + '/project-records';
  projectDataUrl: string = environment.serverUrl + '/compile-data';
  reportAnalysis = [];
  isLoading: boolean = false;
  @ViewChild('htmlData1') htmlData1!: ElementRef;
  selectedOption: string | null = null;
  selectedRows = [];
  signedInUser;
  isSubmitted: boolean = false;
  submitMessage?: string;
  submitStatus = true;
  disablePassCheckbox = false;
  disableFailCheckbox = false;

  constructor(private http: HttpClient,
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog,
    private storageService: StorageService,
    public datepipe: DatePipe,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.authService.getCurrentUser((err, user: User | undefined) => {
      this.signedInUser = user;
    })
  }

  fetchData() {
    if (!this.projectCode) return;
    this.selectedOption = null;
    this.selectedRows = [];
    this.isLoading = true;
    this.dataFetched = false;
    this.reportAnalysis = [];
    let params = new HttpParams();
    params = params.append('projectId', this.projectCode);
    this.http.get<any>(this.projectRecordUrl, { params: params }).subscribe({
      next: (data) => {
        const projectCodes = data.data || [];

        if (!data.multi_project_found) {
          this.isLoading = false;
          this.dataFetched = true;
          this.ProjectCodeResults = data.data;
          this.ListData();
        }
        else {
          this.dialog.open(DialogComponent, {
            data: { projectCodes },
            width: '500px',
            height: '500px'
          }).afterClosed().subscribe(selectedCodes => {
            if (selectedCodes == null) {
              this.isLoading = false;
              this.projectCode = '';
            }
            else
              this.selectedProjectData(selectedCodes);
          })
        }

      },
      error: (err) => {
        console.error('Error fetching data:', err);
        this.dataFetched = true;
        this.isLoading = false;
        this.reportAnalysis = [];
      }
    });
  }


  selectedProjectData(selectedCodes) {
    this.isLoading = true;
    if (selectedCodes && selectedCodes.length > 0) {
      let params = new HttpParams();
      params = params.append('projectId', JSON.stringify(selectedCodes));
      this.http.get<any>(this.projectRecordUrl, { params: params }).subscribe({
        next: (data) => {
          this.isLoading = false;
          this.dataFetched = true;
          this.ProjectCodeResults = data.data;
          this.ListData();
        },
        error: (err) => {
          console.error('Error fetching data:', err);
          this.dataFetched = true;
          this.isLoading = false;
          this.reportAnalysis = [];
        }
      })
    }
  }

  updateCheckboxAvailability(): void {
    const data = this.dataSource?.data || [];
    this.disablePassCheckbox = !data.some(row => row.run_status === 'Pass');
    this.disableFailCheckbox = !data.some(row => row.run_status === 'Fail');
  }

  ListData() {
    this.dataSource = new MatTableDataSource(this.ProjectCodeResults);
    this.updateCheckboxAvailability();
    setTimeout(() => this.dataSource!.paginator = this.paginator ?? null);
    this.dataSource.sortingDataAccessor = (item: any, property) => {
      switch (property) {
        case 'analysisDate': return new Date(item.analysis_date ?? '');
        case 'RunStatus': return item.run_status;
        case 'UserName': return item.username;
        case 'Run_ID': return item.run_id;
        default: return item[property];
      }
    };
    setTimeout(() => this.dataSource!.sort = this.sort ?? null);
    for (const result of this.ProjectCodeResults) {
      this.reportAnalysis.push(result);
    }
    this.dataSource = new MatTableDataSource(this.reportAnalysis);
    setTimeout(() => this.dataSource!.paginator = this.paginator ?? null);
    setTimeout(() => { this.dataSource!.sort = this.sort ?? null; });
  }

  selectAll(): void {
    this.dataSource?.data.forEach(row => {
      if (!row.flag) {
        const duplicate = this.selectedRows.some(r =>
          r.target === row.target && r.run_id === row.run_id
        );
        if (!duplicate && !row.flag) {
          row.flag = true;
          this.selectedRows.push(row);
        } else if (duplicate) {
          this.snackBar.open(
            'Multiple selection of the same Batch Run ID per same Target Name is not allowed.',
            'Dismiss',
            {
              duration: 4000,
              panelClass: ['warning-snackbar'],
            }
          );
        }
      }
    });
  }

  selectByStatus(status: string): void {
    this.dataSource?.data.forEach(row => {
      if (row.run_status === status && !row.flag) {
        const duplicate = this.selectedRows.some(r => r.target === row.target && r.run_id === row.run_id);
        if (!duplicate && !row.flag) {
          row.flag = true;
          this.selectedRows.push(row);
        } else if (duplicate) {
          this.snackBar.open(
            `Multiple selection of the same Batch Run ID per same Target Name is not allowed.`,
            'Dismiss',
            {
              duration: 4000,
              panelClass: ['warning-snackbar'],
            }
          );
        }
      }
      else if (row.run_status !== status && row.flag) {
        row.flag = false;
        const index = this.selectedRows.findIndex(r => r.run_id === row.run_id && r.analysis_id === row.analysis_id);
        if (index !== -1) {
          this.selectedRows.splice(index, 1);
        }
      }
    });
  }

  onCheckboxChange(option: string, checked: boolean): void {
    if (checked) {
      if (this.selectedOption && this.selectedOption !== option) {
        this.clearSelection(this.selectedOption);
      }
      this.selectedOption = option;

      switch (option) {
        case 'All':
          this.selectAll();
          break;
        case 'Pass':
          this.selectByStatus('Pass');
          break;
        case 'Fail':
          this.selectByStatus('Fail');
          break;
      }
    } else {
      const status = option === 'All' ? null : (option === 'Pass' ? 'Pass' : (option === 'Fail' ? 'Fail' : 'Not Applicable'));
      this.selectedRows = this.selectedRows.filter(row => {
        const isMatch = (status === null || row.run_status === status);
        if (isMatch) {
          row.flag = false;
          return false;
        }
        return true;
      });
      this.selectedOption = null;
    }
  }

  private clearSelection(option: string): void {
    const status = option === 'All' ? null : (option === 'Pass' ? 'Pass' : (option === 'Fail' ? 'Fail' : 'Not Applicable'));
    this.selectedRows = this.selectedRows.filter(row => {
      const isMatch = (status === null || row.run_status === status);
      if (isMatch) {
        row.flag = false;
        return false;
      }
      return true;
    });
  }

  onRowCheckboxChange(row: any, checked: boolean): void {
    if (checked) {
      const duplicate = this.selectedRows.find(r =>
        r.target === row.target && r.run_id === row.run_id
      );
      if (duplicate) {
        this.snackBar.open('Multiple selection of the same Batch Run ID per same Target Name is not allowed.', 'Dismiss', {
          duration: 4000,
          panelClass: ['warning-snackbar'],
        });
        setTimeout(() => {
          row.flag = false;
          checked = false;
        })
        return;
      }
      this.selectedRows.push(row);

    } else {
      const index = this.selectedRows.findIndex(r => r.run_id === row.run_id && r.analysis_id === row.analysis_id);
      if (index !== -1) {
        this.selectedRows.splice(index, 1);
      }
    }
  }

  submitData() {
    this.isSubmitted = true;
    this.submitMessage = ''
    let analysisId = (new Date).getTime().toString();
    const eventDate = new Date();
    const UTCDate = this.datepipe.transform((eventDate), 'yyyy-MM-dd HH:mm:ss', 'UTC');
    const relativePath = [this.signedInUser?.username,
    this.signedInUser?.userId,
      analysisId, 'qPCR', 'Report'].join('/');

    let data = {
      data: this.dataSource.data,
      analysisId: analysisId,
      file_path: relativePath,
      projectCode: this.projectCode,
      userId: this.storageService.get('userId'),
      organization: this.storageService.get('organization'),
      group: this.storageService.get('group'),
      userName: this.storageService.get('userName'),
      userRole: this.storageService.get('access'),
      analysisDate: UTCDate
    }
    this.http.post(this.projectDataUrl, data).subscribe((res) => {
      this.router.navigate(['/default-layout/qpcr-molecule-analysis', analysisId, this.signedInUser.username])
    },
      (error) => {
        console.log(error);
        this.isSubmitted = false;
        this.submitStatus = false;
        this.submitMessage = error.message || 'Submit failed';;
      })
  }


}
